import { vehicleOwnershipConfig } from "components/shared/vehicleOwnership/config";
import { accessPermitRelationTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { dieselFuelTank } from "helpers/models";
import { requiredField, trailerNumber } from "helpers/validators";
import { selectList as accessPermitsList } from "sources/books/accessPermits";
import { deviceNumbersList as trackersList } from "sources/books/trackers";
import { list as transportColumnsList } from "sources/books/transportColumns";

const config = {
    number: {
        // field
        label: "Госномер",
        inputProps: { name: "number", placeholder: "АА 1111 / 777" },
        required: true,
        type: "trailerNumber",
        validators: [requiredField, trailerNumber],
    },
    brandTypeId: {
        // select
        label: "Марка",
        inputProps: { name: "brandTypeId" },
        dictionary: "trailerBrandType",
        relatedFields: true,
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    typeId: {
        // select
        label: "Тип прицепа",
        inputProps: { name: "typeId" },
        dictionary: "trailerType",
        relatedFields: true,
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    ...vehicleOwnershipConfig,
    loadUnloadOptions: {
        // select
        isMulti: true,
        label: "Тип загрузки/выгрузки",
        inputProps: { name: "loadUnloadOptions" },
        dictionary: "loadUnloadType",
        relatedFields: true,
        menuPortalTarget: document.body,
        value: [],
    },
    transportColumnId: {
        // async-select
        label: "Колонна",
        inputProps: { name: "transportColumnId" },
        url: transportColumnsList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    mechanic: {
        name: {
            label: "ФИО механика",
            inputProps: {
                name: "name",
            },
            bWrapper: "row form-group",
        },
        number: {
            label: "Телефон механика",
            bWrapper: "row",
            inputProps: {
                name: "phoneNumber",
            },
        },
    },
    comment: {
        // field
        label: "Cсылки на документы",
        inputProps: { name: "comment" },
        textarea: true,
    },
    trackerId: {
        // async-select
        label: "Трекер",
        inputProps: { name: "trackerId" },
        url: trackersList,
        propName: "deviceNumber",
        menuPortalTarget: document.body,
    },
    isInRefuelingSyncList: {
        // checkbox
        label: "Участвует в планировании АЗС",
        inputProps: { name: "isInRefuelingSyncList" },
        checkbox: true,
    },
    accessPermitIds: {
        label: "Полученные разрешения",
        isMulti: true,
        inputProps: { name: "accessPermitIds" },
        url: (props) =>
            accessPermitsList({ filter: { relationType: accessPermitRelationTypesEnum.Trailer }, ...props }),
        propName: "name",
        menuPortalTarget: document.body,
    },
    fuelTanks: {
        value: [{ ...dieselFuelTank }],
        config: {
            id: {},
            type: {},
            totalVolume: {
                // field
                label: "Объем бака",
                inputProps: {
                    name: "totalVolume",
                    type: "number",
                    min: 0,
                    step: "0.1",
                    pattern: "[0-9]+([.,][0-9]+)?",
                },
            },
            fuelConsumption: {
                // field
                label: "Расход топлива, л/ч",
                inputProps: {
                    name: "fuelConsumption",
                    type: "number",
                    min: 0,
                    step: "0.1",
                    pattern: "[0-9]+([.,][0-9]+)?",
                },
            },
            minimumVolume: {
                // field
                label: "Минимальное кол-во топлива в баке",
                inputProps: {
                    name: "minimumVolume",
                    type: "number",
                    min: 0,
                    step: "0.1",
                    pattern: "[0-9]+([.,][0-9]+)?",
                },
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
